import { generateSearchHistoryKey } from '@/features/search/_utils/local-storage';
import type { fundSheetTypeEnum } from '@/utils/enum';
import type { z } from 'zod';

export const FEATURE_KEY = {
  RS: 'rs-projects-table',
  SS: 'ss-projects-table',
  KS: 'ks-projects-table',
  KS_LOCAL_GOVERNMENT: 'ks-local-government-projects-table',
  KS_INVESTMENT: 'ks-investment-projects-table',
};

const _FundSheetTableColumnSettingsKeyModifier = {
  standard: 'KS',
  'local-government': 'KS_LOCAL_GOVERNMENT',
  investment: 'KS_INVESTMENT',
} as const satisfies Record<z.infer<typeof fundSheetTypeEnum>, string>;

export const SEARCH_HISTORY_KEY = generateSearchHistoryKey('rs-project');
